import {
  calcDrawableChartMode,
  calcQuestionChartMode
} from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export const getChartModeTypes = batches =>
  (batches?.length ?? 0) > 12 ? ['brespondents'] : ['respondents', 'brespondents']

// the type's own rules; the exported resolver then fits the result to the modes the view offers
const calcPreferredChartMode = ({ chartMode, modelChartMode, globalChartMode, batches }) => {
  const mode = calcQuestionChartMode(chartMode, modelChartMode, globalChartMode)

  if ((batches?.length ?? 0) > 12) return 'brespondents'

  if (['pie', 'percents'].includes(mode)) return 'respondents'
  if (mode === 'bpercents') return 'brespondents'

  return mode
}

export const getDefaultChartMode = args =>
  calcDrawableChartMode(calcPreferredChartMode(args), getChartModeTypes(args.batches), {
    globalChartMode: args.globalChartMode
  })
